var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5335 13.6575C118.071 31.8674 113.291 23.5801 113.291 60C113.291 96.4199 118.079 88.1326 86.5335 106.343C54.9959 124.552 64.563 124.552 33.0175 106.343C1.47997 88.1326 6.25958 96.4199 6.25958 60C6.25958 23.5801 1.47207 31.8674 33.0175 13.6575C64.5551 -4.55249 54.988 -4.55249 86.5335 13.6575Z",
    fill: "url(#paint0_linear_965_4655)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.301 29.3078C114.603 34.0875 113.291 40.8895 113.291 59.9922C113.291 96.4121 118.079 88.1248 86.5335 106.335C68.7106 116.629 64.01 121.1 57.603 119.757C54.3007 114.978 55.6121 108.175 55.6121 89.0728C55.6121 52.6529 50.8246 60.9402 82.3701 42.7303C100.201 32.4363 104.894 27.9648 111.301 29.3078Z",
    fill: "url(#paint1_linear_965_4655)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25043 29.0706C4.94815 33.8502 6.25958 40.6523 6.25958 59.755C6.25958 96.1749 1.47207 87.8876 33.0175 106.098C46.5585 113.911 52.5231 118.374 57.4133 119.48C54.3481 114.717 55.6121 107.812 55.6121 89.0726C55.6121 66.4701 53.7714 61.0901 59.9177 55.8997C56.2204 52.6448 49.4499 49.5716 37.1809 42.4852C19.3502 32.1912 14.6575 27.7197 8.25043 29.0627",
    fill: "#491870"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.485 26.4481L59.8228 49.3586L18.6865 26.4639L59.3488 3.5533L100.485 26.4481ZM105.762 26.4481L59.3172 0.598633L13.4092 26.4718L59.8544 52.3212L105.762 26.4481ZM77.2902 16.478C87.1654 21.9766 87.2602 30.9275 77.4956 36.426C67.7309 41.9245 51.7488 41.9324 41.8736 36.4339C31.9983 30.9354 31.9035 21.9845 41.6682 16.4859C51.4328 10.9874 67.4149 10.9795 77.2902 16.478ZM79.913 15.0007C68.5525 8.68053 50.2399 8.68053 39.0137 15.0086C27.7875 21.3366 27.8902 31.5911 39.2507 37.9112C50.6112 44.2314 68.9239 44.2314 80.15 37.9034C91.3762 31.5753 91.2735 21.3208 79.913 15.0007ZM74.8411 34.9566C83.1758 30.2639 83.0968 22.656 74.6673 17.9633C66.2378 13.2705 52.6495 13.2784 44.3226 17.9633C35.9879 22.656 36.0669 30.2639 44.4965 34.9566C52.926 39.6493 66.5143 39.6414 74.8411 34.9566Z",
    fill: "#9D4CDD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.078 54.4163C102.654 53.7111 102.048 53.2388 101.305 53.031L87.6754 49.3412C85.6213 48.7871 82.8804 50.3487 80.8762 53.2136L67.6399 72.1412C66.1851 74.2317 65.3485 76.7126 65.386 78.8282L65.7793 98.2721C65.8542 101.855 68.4516 103.322 71.5796 101.565L78.5224 97.6551C80.9636 96.2761 82.9116 92.8948 82.8804 90.0929L82.7805 83.0532C82.7805 82.7636 82.6244 82.5873 82.3871 82.5999C79.4714 82.7888 78.0916 79.6657 79.2966 75.6169C79.7149 74.2065 80.4204 72.8087 81.3257 71.5871L81.4069 77.0715C81.4069 77.3485 81.5505 77.5311 81.769 77.5311L84.3351 77.5563C84.5162 77.5563 84.7285 77.4367 84.9095 77.2352L87.4382 74.3261C87.6505 74.0806 87.7878 73.7469 87.7816 73.4698L87.7129 67.9729C90.3789 68.5081 91.1343 72.2105 89.4111 76.2403C88.8118 77.6382 87.9626 78.9479 86.9637 80.0183C86.7327 80.2701 86.589 80.6165 86.589 80.9061L86.6765 87.952C86.7139 90.754 88.7306 91.9063 91.1781 90.5336L98.1646 86.6045C101.324 84.8226 103.865 80.4401 103.846 76.807L103.715 57.0986C103.709 56.0471 103.484 55.1278 103.066 54.4226L103.078 54.4163Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_965_4655",
    x1: 60,
    y1: 51,
    x2: 57.9868,
    y2: 12.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55217E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9554C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_965_4655",
    x1: 62.9998,
    y1: 58,
    x2: 97.9998,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55217E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9554C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.f9b2bbd0.svg";
export { ForwardRef as ReactComponent };